import { render } from "./Notion.vue?vue&type=template&id=211203be"
import script from "./Notion.vue?vue&type=script&lang=js"
export * from "./Notion.vue?vue&type=script&lang=js"

import "./Notion.vue?vue&type=style&index=0&id=211203be&lang=css"
script.render = render

export default script